import { render, staticRenderFns } from "./TruckTrackingDetail.vue?vue&type=template&id=2474463e&scoped=true&"
import script from "./TruckTrackingDetail.vue?vue&type=script&lang=js&"
export * from "./TruckTrackingDetail.vue?vue&type=script&lang=js&"
import style0 from "./TruckTrackingDetail.vue?vue&type=style&index=0&id=2474463e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2474463e",
  null
  
)

export default component.exports